import React from 'react';
import {
    GuestGuard,
} from '../guards/RolesGuard';
import { UserGuard } from '../guards/UserGuard';
import Layout from '../container/Layout';
import Homepage from '../features/dashboard/homepage';
import Settings from '../features/dashboard/settings';
import RootRedirect from '../features/dashboard/redirect/RootRedirect';
import AiAuth from '../features/ai-auth/AiAuth';
import AiRegister from '../features/ai-auth/Register';
import Claire2Tab from '../features/dashboard/homepage/tabs/Claire2Tab';

export interface RouteDefinition {
    path: string;
    element: JSX.Element;
    guard?: () => boolean;
    index?: string;
    key?: string;
    childrens?: RouteDefinition[];
}

export const routes: RouteDefinition[] = [
    {
        path: '/auth',
        element: <AiAuth />,
        key: 'guest',
        guard: GuestGuard,
    },
    {
        path: '/register',
        element: <AiRegister />,
        key: 'guest',
        guard: GuestGuard,
    },
    {
        path: '/',
        element: <RootRedirect />,
        guard: UserGuard,
    },
    {
        path: '/insights',
        element: <Layout />,
        key: 'admin',
        guard: UserGuard,
        childrens: [
            {
                path: '',
                element: <Homepage />
            },
        ]
    },
    {
        path: '/settings',
        element: <Layout />,
        key: 'admin',
        guard: UserGuard,
        childrens: [
            {
                path: '',
                element: <Settings />
            }
        ]
    },
    {
        path: '/claire-2',
        element: <Layout />,
        key: 'admin',
        guard: UserGuard,
        childrens: [
            {
                path: '',
                element: <Claire2Tab />
            },
        ]
    },
];
